import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import WelcomeScreen from './screens/WelcomeScreen';
import LandingScreen from './screens/LandingScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import HomeScreen from './screens/HomeScreen';
import VideoChatScreen from './screens/VideoChatScreen';
import BecomeStarScreen from './screens/BecomeStarScreen';
import TermsCondition from './screens/TermsCondition';
import PrivacyPolicy from './screens/PrivacyPolicy';
import PricingPage from './screens/PricingPage';
import RefundPolicy from './screens/RefundPolicy';
import PrivateRoute from './components/PrivateRoute';
import {useAuth, AuthProvider} from './contexts/AuthContext';
import InstagramCallback from './components/InstagramCallback';
import YoutubeCallback from './components/YoutubeCallback';
import TikTokCallback from './components/TiktokCallback';
import SearchScreen from './screens/SearchScreen';
import ManageAvailabilityScreen from './screens/ManageAvailablilityScreen';
import StarProfileScreen from './screens/StarProfileScreen';
import SettingsScreen from './screens/SettingsScreen';
import MyBookingsScreen from './screens/MyBookingsScreen';
import CallScreen from './screens/CallScreen';
import BuyCredits from './screens/BuyCredits';
import PayoutsScreen from './screens/PayoutsScreen';
import {NotificationProvider} from './contexts/NotificationContext';
import {Layout} from './components/Layout';
import {StripeProvider} from './components/PaymentForm';
import BookingModal from './components/BookingModal';
import {Toaster} from 'react-hot-toast';
import {ColorThemeProvider} from './contexts/ColorThemeContext';
import BuyCreditsCreemScreen from './screens/BuyCreditsCreem';
import PaymentSuccessScreen from './screens/PaymentSuccess';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';

const AppRoutes: React.FC = () => {
  const {user, loading} = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-gray-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  return (
    <>
      <Toaster position="bottom-center" reverseOrder={false} />

      <Routes>
        <Route path="/auth/tiktok/callback" element={<TikTokCallback />} />
        <Route path="/auth/youtube/callback" element={<YoutubeCallback />} />
        <Route
          path="/auth/instagram/callback"
          element={<InstagramCallback />}
        />
        <Route
          path="/"
          element={user ? <Navigate to="/home" /> : <LandingScreen />}
        />
        <Route
          path="/welcome"
          element={user ? <Navigate to="/home" /> : <WelcomeScreen />}
        />
        <Route
          path="/login"
          element={user ? <Navigate to="/home" /> : <LoginScreen />}
        />
        <Route
          path="/register"
          element={user ? <Navigate to="/home" /> : <RegisterScreen />}
        />
        <Route
          path="/terms"
          element={<TermsCondition />}
        />
        <Route
          path="/privacy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/pricing"
          element={<PricingPage />}
        />
        <Route
          path="/refund-policy"
          element={<RefundPolicy />}
        />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              {/* <HomeScreen /> */}
              <SearchScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/manage-availability"
          element={
            <PrivateRoute>
              <ManageAvailabilityScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute skipProfileCheck>
              <SettingsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/search"
          element={
            <PrivateRoute>
              <SearchScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-bookings"
          element={
            <PrivateRoute>
              <MyBookingsScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/call/:callId"
          element={
            <PrivateRoute>
              <CallScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/video-chat"
          element={
            <PrivateRoute>
              <VideoChatScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/become-star"
          element={
            <PrivateRoute>
              <BecomeStarScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/star/:starId"
          element={
            <PrivateRoute>
              <StarProfileScreen />
            </PrivateRoute>
          }
        />

        <Route
          path="/buy-credits"
          element={
            <PrivateRoute>
              <BuyCreditsCreemScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-success"
          element={
            <PrivateRoute>
              <PaymentSuccessScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/payouts"
          element={
            <PrivateRoute>
              <PayoutsScreen />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

const App: React.FC = () => {
  return (
    <StripeProvider>
      <AuthProvider>
        <ColorThemeProvider>
          <NotificationProvider>
            <Router>
              <AnalyticsTracker />
              <ScrollToTop />
              <Layout>
                <AppRoutes />
              </Layout>
            </Router>
          </NotificationProvider>
        </ColorThemeProvider>
      </AuthProvider>
    </StripeProvider>
  );
};

export default App;
